import { useLocation } from 'react-router-dom'; // Add this
import React, { useState } from 'react'; // Added useState here
import BottomNav from '../components/BottomNav';
import NavBar from '../components/NavBar';
import Login from '../components/user/Login';
import { useValue } from '../context/ContextProvider';
//import Landing from './Landing';

// Import your tab components directly
import ClusterMap from '../components/map/ClusterMap'; 
import Points from '../components/points/Points';
import AboutUs from '../components/aboutUs/AboutUs';
import Sidebar from '../components/sidebar/Sidebar';
import UCIpoints from '../components/uciPoints/UCIpoints';


const Home = () => {
  const { state: { currentView } } = useValue();
  const location = useLocation(); // Hook to track current URL path
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Manage state here

  //if (currentView === 'Landing') return <Landing />;

  return (
    <>
      <Login />
      <NavBar setIsOpen={setIsSidebarOpen} /> {/* Pass setter to your navbar toggle */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      
      <main style={{ paddingBottom: '60px', height: '100vh' }}> 
        {/* Map Tab: Persistent in DOM */}
        <div style={{ 
          display: location.pathname === '/map' || location.pathname === '/' ? 'block' : 'none',
          height: '100%' 
        }}>
          <ClusterMap />
        </div>

        {/* Points Tab: Persistent in DOM */}
        <div style={{ display: location.pathname === '/points' ? 'block' : 'none' }}>
          <Points />
        </div>

        {/* UCI Points Tab: Persistent in DOM */}
        <div style={{ display: location.pathname === '/ucipoints' ? 'block' : 'none' }}>
          <UCIpoints />
        </div>

        {/* About Us Tab: Persistent in DOM */}
        <div style={{ display: location.pathname === '/about' ? 'block' : 'none' }}>
          <AboutUs />
        </div>
      </main>

      <BottomNav />
    </>
  );
};

export default Home;
